"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keysToLowerCase = exports.keysToCamel = exports.getFirstOrDefault = exports.getEnumValues = exports.removeByIndex = exports.removePrefix = exports.removePostfix = exports.cloneArray = exports.sortAlphabetically = exports.sortByKey = exports.getStringCompareFunction = exports.fromObjectToArray = exports.fromArrayToObject = exports.findIndex = void 0;
var tslib_1 = require("tslib");
var webexUI_1 = require("webexUI");
var String_utils_1 = require("./String.utils");
function findIndex(arr, cb) {
    if (!arr || arr.length === 0) {
        return -1;
    }
    var i = 0;
    var len = arr.length;
    while (i < len) {
        if (cb(arr[i], i)) {
            return i;
        }
        i++;
    }
    return -1;
}
exports.findIndex = findIndex;
var fromArrayToObject = function (array, keyField) {
    return (0, webexUI_1.safe)(array).reduce(function (obj, item) {
        if (item) {
            obj[item[keyField]] = item;
        }
        return obj;
    }, {});
};
exports.fromArrayToObject = fromArrayToObject;
var fromObjectToArray = function (object) { return Object.keys(object).map(function (k) { return object[k]; }); };
exports.fromObjectToArray = fromObjectToArray;
var getStringCompareFunction = function (key, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = false; }
    return function (a, b) {
        return (0, String_utils_1.compareString)(a[key], b[key], ignoreCase);
    };
};
exports.getStringCompareFunction = getStringCompareFunction;
var sortByKey = function (array, key, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = false; }
    return array.sort((0, exports.getStringCompareFunction)(key, ignoreCase));
};
exports.sortByKey = sortByKey;
var sortAlphabetically = function (arrayOfStrings, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = true; }
    return arrayOfStrings.sort(function (a, b) {
        return (0, String_utils_1.compareString)(a, b, ignoreCase);
    });
};
exports.sortAlphabetically = sortAlphabetically;
var cloneArray = function (array) {
    return array.map(function (a) { return (tslib_1.__assign({}, a)); });
};
exports.cloneArray = cloneArray;
var removePostfix = function (source, postfix) {
    var result = source;
    if (result && postfix && result.substr(-postfix.length) === postfix) {
        result = result.substr(0, result.length - postfix.length);
    }
    return result;
};
exports.removePostfix = removePostfix;
var removePrefix = function (source, prefix) {
    var result = source;
    if (result && prefix && result.indexOf(prefix, 0) === 0) {
        result = result.substr(prefix.length);
    }
    return result;
};
exports.removePrefix = removePrefix;
var removeByIndex = function (source, index) {
    if (index !== -1) {
        var clone = source.slice(0);
        clone.splice(index, 1);
        return clone;
    }
    return source;
};
exports.removeByIndex = removeByIndex;
var getEnumValues = function (source) {
    var names = Object.keys(source).filter(function (key) { return isNaN(+key); });
    return names.map(function (name) { return source[name]; });
};
exports.getEnumValues = getEnumValues;
var getFirstOrDefault = function (source, defaultValue, cb) {
    if (cb === void 0) { cb = null; }
    if (!source || source.length < 1) {
        return defaultValue;
    }
    if (cb) {
        source = source.filter(cb);
    }
    return source.length > 0 ? source[0] : defaultValue;
};
exports.getFirstOrDefault = getFirstOrDefault;
var isObject = function (o) {
    return o === Object(o) && !Array.isArray(o) && typeof o !== 'function';
};
var toCamel = function (s) {
    return s.replace(/([-_][a-z])/gi, function ($1) {
        return $1.toUpperCase().replace('-', '').replace('_', '');
    });
};
var keysToCamel = function (o) {
    if (isObject(o)) {
        var n_1 = {};
        Object.keys(o).forEach(function (k) {
            var key = (0, String_utils_1.lowerFirstLetter)(k);
            n_1[toCamel(key)] = (0, exports.keysToCamel)(o[k]);
        });
        return n_1;
    }
    else if (Array.isArray(o)) {
        return o.map(function (i) {
            return (0, exports.keysToCamel)(i);
        });
    }
    return o;
};
exports.keysToCamel = keysToCamel;
var keysToLowerCase = function (originalObject) {
    if (!isObject(originalObject))
        return originalObject;
    return Object.keys(originalObject).reduce(function (acc, currKey) {
        acc[currKey.toLowerCase()] = originalObject[currKey];
        return acc;
    }, {});
};
exports.keysToLowerCase = keysToLowerCase;
